/**
 * Convierte un objeto Date a string ISO 8601 en hora LOCAL (no UTC).
 * Formato: "YYYY-MM-DDTHH:MM:SS"
 *
 * A diferencia de date.toISOString() que convierte a UTC,
 * esta función preserva la hora tal como el usuario la seleccionó.
 *
 * @param {Date} date - Objeto Date
 * @returns {string} Fecha en formato "YYYY-MM-DDTHH:MM:SS"
 *
 * @example
 * // Usuario en UTC-6 selecciona 15:30
 * toLocalISOString(date)  // → "2026-06-13T15:30:00"
 * date.toISOString()      // → "2026-06-13T21:30:00.000Z"  ❌ UTC
 */
export const toLocalISOString = (date) => {
  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${date.getFullYear()}-` +
    `${pad(date.getMonth() + 1)}-` +
    `${pad(date.getDate())}T` +
    `${pad(date.getHours())}:` +
    `${pad(date.getMinutes())}:` +
    `${pad(date.getSeconds())}`
  );
};

/**
 * Convierte un objeto Date a string de solo fecha en hora LOCAL.
 * Formato: "YYYY-MM-DD"
 *
 * @param {Date} date - Objeto Date
 * @returns {string} Fecha en formato "YYYY-MM-DD"
 */
export const toLocalDateString = (date) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
